/*
 * PRODUCT page (sections/main-product.liquid): "BACK TO SHOP" is a plain
 * <a href="{routes.all_products_collection_url}"> by default — always
 * the bare, unfiltered Shop URL, since Liquid has no way to know what
 * filters/sort the visitor actually had active before clicking into this
 * product. That drops any active category filter (or IN STOCK ONLY, or
 * sort order) the visitor had on the Shop page, unlike the browser's own
 * back button, which naturally returns to the exact prior URL.
 *
 * Fixed here by rewriting the link's href, once, on load: if the visitor
 * arrived here from a Shop URL (document.referrer starts with the same
 * collection path), point "BACK TO SHOP" at that exact URL — filters and
 * all — instead of the bare one. Left as the default bare URL for every
 * other case (direct visit, arrived from somewhere else), so there's
 * always a sensible destination either way.
 *
 * A plain href rewrite, not a click handler — the link still behaves as
 * an ordinary navigation, so it has none of the bfcache-timing issues an
 * earlier history.back()-based attempt here ran into.
 */
(function () {
  var link = document.querySelector('[data-back-to-shop]');
  if (!link) return;

  var shopUrlPrefix = link.getAttribute('data-shop-url-prefix');
  if (!shopUrlPrefix) return;

  try {
    var referrer = new URL(document.referrer);
    var cameFromShop = referrer.origin === window.location.origin
      && referrer.pathname === shopUrlPrefix;

    if (cameFromShop) {
      link.href = referrer.pathname + referrer.search;
    }
  } catch (error) {
    // Malformed/empty referrer (direct visit, etc.) — leave the default
    // bare Shop URL in place.
  }
})();
